// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-check:checked + .btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check) + .btn:active {
  color: inherit;
  border-color: inherit;
  background-color: inherit;
}

.btn {
  border-color: var(--brand-color);
  transition: var(--default-transition);
  color: var(--text-color);
  /* fancy button */
}
.btn:hover {
  background-color: var(--brand-color);
  border-color: var(--brand-color);
}
.btn:focus:not([class*=btn-slide]), .btn:active:not([class*=btn-slide]) {
  color: var(--brand-color);
  box-shadow: none;
  background: transparent;
  border-color: var(--brand-color);
  outline: none;
}
.btn.btn-xl {
  font-size: 14px;
  line-height: normal;
  padding: 16px 40px;
}
.btn.btn-lg {
  font-size: 13px;
  line-height: normal;
  padding: 12px 32px;
}
.btn.btn-md {
  font-size: 12px;
  line-height: normal;
  padding: 10px 26px;
}
.btn.btn-sm {
  font-size: 11px;
  line-height: normal;
  padding: 8px 22px;
}
.btn.btn-xs {
  font-size: 10px;
  line-height: 1.5;
  padding: 6px 16px;
}
.btn.btn-fancy.btn-xs {
  font-size: 10px;
  letter-spacing: 0.5px;
  padding: 7px 18px;
}
.btn.btn-fancy.btn-sm {
  font-size: 11px;
  letter-spacing: 0.5px;
  padding: 10px 24px;
}
.btn.btn-fancy.btn-md {
  font-size: 12px;
  letter-spacing: 1px;
  padding: 12px 28px;
}
.btn.btn-fancy.btn-lg {
  font-size: 13px;
  letter-spacing: 1px;
  padding: 13px 32px;
}
.btn.btn-fancy.btn-xl {
  font-size: 15px;
  letter-spacing: 1px;
  padding: 18px 38px;
}
.btn.btn-gradient {
  background: var(--brand-color);
  color: var(--text-color);
  border-color: transparent;
  background-size: 200% auto;
}
.btn.btn-gradient:active, .btn.btn-gradient:focus {
  background: var(--brand-color);
  border-color: transparent;
  color: var(--text-color);
  background-size: 200%;
}
.btn.btn-gradient.btn-transparent {
  background: transparent;
  border-image-source: var(--brand-color);
  border-image-slice: 1;
}
.btn.btn-gradient:hover {
  background-position: right center;
}
.btn.btn-fill {
  background-color: var(--brand-color);
}
.btn.btn-fill:hover {
  background-color: transparent;
  color: var(--brand-color);
}
.btn[class*=btn-slide] {
  position: relative;
  z-index: 1;
  overflow: hidden;
  background-size: 200% auto;
}
.btn[class*=btn-slide]:focus, .btn[class*=btn-slide]:active {
  color: var(--text-color);
}
.btn[class*=btn-slide].btn-slide-filling-up:focus[role=button], .btn[class*=btn-slide].btn-slide-filling-up:active[role=button], .btn[class*=btn-slide].btn-slide-filling-down:focus[role=button], .btn[class*=btn-slide].btn-slide-filling-down:active[role=button], .btn[class*=btn-slide].btn-slide-filling-left:focus[role=button], .btn[class*=btn-slide].btn-slide-filling-left:active[role=button], .btn[class*=btn-slide].btn-slide-filling-right:focus[role=button], .btn[class*=btn-slide].btn-slide-filling-right:active[role=button] {
  border-color: transparent;
}
.btn[class*=btn-slide]:hover {
  background-position: right center;
}
.btn[class*=btn-slide]:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: var(--brand-color);
  transition: var(--default-transition);
}
.btn.btn-slide-up::after {
  transform: translateY(100%);
}
.btn.btn-slide-up:hover:not(:active):after {
  transform: translateY(0);
}
.btn.btn-slide-down:after {
  transform: translateY(-100%);
}
.btn.btn-slide-down:hover:not(:active):after {
  transform: translateY(0);
}
.btn.btn-slide-left:after {
  transform: translateX(100%);
}
.btn.btn-slide-left:hover:not(:active):after {
  transform: translateX(0);
}
.btn.btn-slide-right:after {
  transform: translateX(-100%);
}
.btn.btn-slide-right:hover:not(:active):after {
  transform: translateX(0);
}
.btn[class*=btn-slide-filling]:not(:active) {
  border-color: transparent;
}
.btn.btn-slide-filling-up::after {
  transform: translateY(100%);
  background-color: var(--brand-color);
}
.btn.btn-slide-filling-up:hover:not(:active):after {
  transform: translateY(0);
}
.btn.btn-slide-filling-down::after {
  transform: translateY(calc(-100% - 1px));
  background-color: var(--brand-color);
}
.btn.btn-slide-filling-down:hover:not(:active):after {
  transform: translateY(0);
}
.btn.btn-slide-filling-left::after {
  transform: translateX(100%);
  background-color: var(--brand-color);
}
.btn.btn-slide-filling-left:hover:not(:active):after {
  transform: translateX(0);
}
.btn.btn-slide-filling-right::after {
  transform: translateX(calc(-100% - 1px));
  background-color: var(--brand-color);
}
.btn.btn-slide-filling-right:hover:not(:active):after {
  transform: translateX(0);
}
.btn.btn-expand {
  border: none;
  background-color: transparent;
  position: relative;
  z-index: 1;
}
.btn.btn-expand:active, .btn.btn-expand:focus {
  color: var(--text-color) !important;
}
.btn.btn-expand .right-icon {
  transition: var(--default-transition);
}
.btn.btn-expand.rounded:after {
  border-radius: 50px;
}
.btn.btn-expand.rounded.btn-xl {
  padding: 15px 28px 15px;
}
.btn.btn-expand.rounded.btn-xl:after {
  width: 50px;
  height: 50px;
}
.btn.btn-expand.rounded.btn-lg {
  padding: 14px 26px 14px;
}
.btn.btn-expand.rounded.btn-lg:after {
  width: 46px;
  height: 46px;
}
.btn.btn-expand.rounded.btn-md {
  padding: 7px 21px 7px;
}
.btn.btn-expand.rounded.btn-md:after {
  width: 32px;
  height: 32px;
}
.btn.btn-expand.rounded.btn-sm {
  padding: 7px 20px 7px;
}
.btn.btn-expand.rounded.btn-sm:after {
  width: 30px;
  height: 30px;
}
.btn.btn-expand.rounded.btn-xs {
  padding: 5px 17px 5px;
}
.btn.btn-expand.rounded.btn-xs:after {
  width: 25px;
  height: 25px;
}
.btn.btn-expand:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 50%;
  height: 100%;
  z-index: -1;
  background-color: var(--brand-color);
  transition: var(--default-transition);
  transform: translateY(-50%);
}
.btn.btn-expand:hover .right-icon {
  margin-left: 15px;
}
.btn.btn-expand:hover:after {
  width: 100% !important;
  color: var(--text-color);
}
.btn.btn-link {
  padding: 7px 0 2px;
  position: relative;
  border: 0;
  background-color: transparent;
  text-decoration: none;
}
.btn.btn-link::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
}
.btn.btn-link:focus-visible {
  color: var(--text-color);
  box-shadow: none;
}
.btn.btn-link:hover {
  opacity: 0.7;
}
.btn.btn-link:hover:after {
  opacity: 0.7;
}
.btn.text-gradient {
  background: var(--text-color);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.btn.text-gradient:focus[role=button], .btn.text-gradient:active[role=button] {
  background: var(--text-color) !important;
  -webkit-background-clip: text !important;
  background-clip: text !important;
  -webkit-text-fill-color: transparent;
}
.btn.btn-shadow {
  letter-spacing: 1px;
}
.btn.btn-shadow:hover {
  box-shadow: 0 8px 30px -5px rgba(0, 0, 0, 0.2) !important;
  transform: translate3d(0, -3px, 0);
  background-color: var(--brand-color) !important;
  color: var(--text-color) !important;
}
.btn.btn-shadow:focus, .btn.btn-shadow:active {
  box-shadow: 0 8px 30px -5px rgba(0, 0, 0, 0.2) !important;
  background-color: var(--brand-color) !important;
  color: var(--text-color) !important;
}
.btn.btn-flat {
  border-color: var(--brand-color);
  color: var(--brand-color);
  border-width: 1px;
  background-color: transparent;
  box-shadow: 2px 2px 0 var(--brand-color);
}
.btn.btn-flat:hover, .btn.btn-flat:active, .btn.btn-flat:focus {
  background: var(--brand-color) !important;
  border-color: transparent !important;
  box-shadow: none !important;
  color: var(--text-color) !important;
}
.btn.btn-sonar {
  background-color: transparent;
  display: flex;
  font-size: 14px;
  position: relative;
  padding: 0;
  line-height: 1;
  justify-content: center;
  align-items: center;
  border-radius: 9999px;
}
.btn.btn-sonar.btn-sm {
  width: 40px;
  height: 40px;
  font-size: 14px;
}
.btn.btn-sonar.btn-md {
  width: 50px;
  height: 50px;
  font-size: 18px;
}
.btn.btn-sonar.btn-lg {
  width: 75px;
  height: 75px;
  font-size: 26px;
}
.btn.btn-sonar.btn-xl {
  width: 100px;
  height: 100px;
  font-size: 25px;
}
.btn.btn-sonar.btn-xxl {
  width: 120px;
  height: 120px;
  font-size: 34px;
}
@media (max-width: var(--sm)) {
  .btn.btn-sonar.btn-xxl {
    width: 80px;
    height: 80px;
    font-size: 28px;
  }
}
.btn.btn-sonar i {
  position: relative;
  z-index: 6;
  color: var(--text-color);
  margin-left: 8px;
}
.btn.btn-sonar::before {
  content: "";
  position: absolute;
  opacity: 1;
  top: 0;
  left: 0;
  --transform-translate-x: -50%;
  --transform-translate-y: -50%;
  width: 100%;
  height: 100%;
  border-radius: 9999px;
  z-index: 5;
  background: var(--brand-color);
  background-size: 200%;
}
.btn.btn-sonar::after {
  content: "";
  width: 150%;
  height: 150%;
  opacity: 2;
  position: absolute;
  top: 50%;
  left: 50%;
  --transform-translate-x: -50%;
  --transform-translate-y: -50%;
  border-radius: 9999px;
  z-index: 3;
  background: var(--brand-color);
  animation: video-icon-sonar 2s linear infinite;
}
.btn.btn-sonar:hover {
  border: none;
}
.btn .left-icon {
  margin-right: 8px;
}
.btn .right-icon {
  margin-left: 8px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
[type=submit].loading {
  position: relative;
}
[type=submit].loading:before {
  content: "";
  background-color: rgba(255, 255, 255, 0.8) !important;
  position: absolute;
  right: 2px;
  top: 1px;
  width: calc(100% - 4px);
  height: calc(100% - 2px);
  border-radius: inherit;
  z-index: 1;
}
[type=submit].loading:after {
  background: 0 0;
  content: "" !important;
  position: absolute;
  left: calc(50% - 10px) !important;
  top: calc(50% - 10px) !important;
  width: 20px !important;
  height: 20px !important;
  opacity: 1 !important;
  right: inherit !important;
  z-index: 9;
  text-align: center;
  border: 2px solid rgba(23, 23, 23, 0.2);
  border-top-color: rgba(23, 23, 23, 0.7);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  -webkit-animation: spin 1s linear infinite;
}
[type=submit].loading.dark:before {
  background-color: rgba(0, 0, 0, 0.8) !important;
}
[type=submit].loading.dark:after {
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-top-color: rgba(255, 255, 255, 0.7);
}`, "",{"version":3,"sources":["webpack://./src/Assets/scss/components/_button.scss"],"names":[],"mappings":"AAAA;;;;;EAKE,cAAA;EACA,qBAAA;EACA,yBAAA;AACF;;AAEA;EACE,gCAAA;EACA,qCAAA;EACA,wBAAA;EAgDA,iBAAA;AA9CF;AAAE;EACE,oCAAA;EACA,gCAAA;AAEJ;AAGI;EACE,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gCAAA;EACA,aAAA;AADN;AAKE;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AAHJ;AAME;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AALJ;AAQE;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;AANJ;AASE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAPJ;AAYI;EACE,eAAA;EACA,qBAAA;EACA,iBAAA;AAVN;AAaI;EACE,eAAA;EACA,qBAAA;EACA,kBAAA;AAXN;AAcI;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AAZN;AAeI;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AAbN;AAgBI;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AAdN;AAkBE;EACE,8BAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;AAhBJ;AAkBI;EAEE,8BAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;AAjBN;AAoBI;EACE,uBAAA;EACA,uCAAA;EACA,qBAAA;AAlBN;AAqBI;EACE,iCAAA;AAnBN;AAuBE;EACE,oCAAA;AArBJ;AAuBI;EACE,6BAAA;EACA,yBAAA;AArBN;AAyBE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,0BAAA;AAvBJ;AAyBI;EAEE,wBAAA;AAxBN;AAkCQ;EACE,yBAAA;AAhCV;AAqCI;EACE,iCAAA;AAnCN;AAsCI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;EACA,qCAAA;AApCN;AAyCI;EACE,2BAAA;AAvCN;AA2CM;EACE,wBAAA;AAzCR;AA+CI;EACE,4BAAA;AA7CN;AAiDM;EACE,wBAAA;AA/CR;AAqDI;EACE,2BAAA;AAnDN;AAuDM;EACE,wBAAA;AArDR;AA2DI;EACE,4BAAA;AAzDN;AA6DM;EACE,wBAAA;AA3DR;AAiEI;EACE,yBAAA;AA/DN;AAoEI;EACE,2BAAA;EACA,oCAAA;AAlEN;AAsEM;EACE,wBAAA;AApER;AA0EI;EACE,wCAAA;EACA,oCAAA;AAxEN;AA4EM;EACE,wBAAA;AA1ER;AAgFI;EACE,2BAAA;EACA,oCAAA;AA9EN;AAkFM;EACE,wBAAA;AAhFR;AAsFI;EACE,wCAAA;EACA,oCAAA;AApFN;AAwFM;EACE,wBAAA;AAtFR;AA2FE;EACE,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,UAAA;AAzFJ;AA2FI;EAEE,mCAAA;AA1FN;AA6FI;EACE,qCAAA;AA3FN;AA+FM;EACE,mBAAA;AA7FR;AAgGM;EACE,uBAAA;AA9FR;AAgGQ;EACE,WAAA;EACA,YAAA;AA9FV;AAkGM;EACE,uBAAA;AAhGR;AAkGQ;EACE,WAAA;EACA,YAAA;AAhGV;AAoGM;EACE,qBAAA;AAlGR;AAoGQ;EACE,WAAA;EACA,YAAA;AAlGV;AAsGM;EACE,qBAAA;AApGR;AAsGQ;EACE,WAAA;EACA,YAAA;AApGV;AAwGM;EACE,qBAAA;AAtGR;AAwGQ;EACE,WAAA;EACA,YAAA;AAtGV;AA2GI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;AAzGN;AA6GM;EACE,iBAAA;AA3GR;AA8GM;EACE,sBAAA;EACA,wBAAA;AA5GR;AAiHE;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,6BAAA;EACA,qBAAA;AA/GJ;AAiHI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;AA/GN;AAkHI;EACE,wBAAA;EACA,gBAAA;AAhHN;AAmHI;EACE,YAAA;AAjHN;AAmHM;EACE,YAAA;AAjHR;AAsHE;EACE,6BAAA;EACA,6BAAA;EACA,qBAAA;EACA,oCAAA;AApHJ;AAwHM;EACE,wCAAA;EACA,wCAAA;EACA,gCAAA;EACA,oCAAA;AAtHR;AA2HE;EACE,mBAAA;AAzHJ;AA2HI;EACE,yDAAA;EAEA,kCAAA;EACA,+CAAA;EACA,mCAAA;AAzHN;AA4HI;EAEE,yDAAA;EACA,+CAAA;EACA,mCAAA;AA3HN;AA+HE;EACE,gCAAA;EACA,yBAAA;EACA,iBAAA;EACA,6BAAA;EACA,wCAAA;AA7HJ;AA+HI;EAGE,yCAAA;EACA,oCAAA;EACA,2BAAA;EACA,mCAAA;AA/HN;AAmIE;EACE,6BAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AAjIJ;AAmII;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAjIN;AAoII;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAlIN;AAqII;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAnIN;AAsII;EACE,YAAA;EACA,aAAA;EACA,eAAA;AApIN;AAuII;EACE,YAAA;EACA,aAAA;EACA,eAAA;AArIN;AAuIM;EALF;IAMI,WAAA;IACA,YAAA;IACA,eAAA;EApIN;AACF;AAuII;EACE,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,gBAAA;AArIN;AAwII;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,6BAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;EACA,8BAAA;EACA,qBAAA;AAtIN;AAyII;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;EACA,6BAAA;EACA,qBAAA;EACA,UAAA;EACA,8BAAA;EACA,8CAAA;AAvIN;AA0II;EACE,YAAA;AAxIN;AA4IE;EACE,iBAAA;AA1IJ;AA6IE;EACE,gBAAA;AA3IJ;;AA+IA;EACE;IAGE,yBAAA;EA5IF;AACF;AAgJE;EACE,kBAAA;AA9IJ;AAgJI;EACE,WAAA;EACA,qDAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,uBAAA;EACA,wBAAA;EACA,sBAAA;EACA,UAAA;AA9IN;AAiJI;EACE,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,gCAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,uCAAA;EACA,uCAAA;EACA,kBAAA;EACA,kCAAA;EACA,0CAAA;AA/IN;AAmJM;EACE,+CAAA;AAjJR;AAoJM;EACE,0CAAA;EACA,0CAAA;AAlJR","sourcesContent":[".btn-check:checked+.btn,\n.btn.active,\n.btn.show,\n.btn:first-child:active,\n:not(.btn-check)+.btn:active {\n  color: inherit;\n  border-color: inherit;\n  background-color: inherit;\n}\n\n.btn {\n  border-color: var(--brand-color);\n  transition: var(--default-transition);\n  color: var(--text-color);\n\n  &:hover {\n    background-color: var(--brand-color);\n    border-color: var(--brand-color);\n  }\n\n  &:focus,\n  &:active {\n    &:not([class*=\"btn-slide\"]) {\n      color: var(--brand-color);\n      box-shadow: none;\n      background: transparent;\n      border-color: var(--brand-color);\n      outline: none;\n    }\n  }\n\n  &.btn-xl {\n    font-size: 14px;\n    line-height: normal;\n    padding: 16px 40px;\n  }\n\n  &.btn-lg {\n    font-size: 13px;\n    line-height: normal;\n    padding: 12px 32px;\n  }\n\n  &.btn-md {\n    font-size: 12px;\n    line-height: normal;\n    padding: 10px 26px;\n  }\n\n  &.btn-sm {\n    font-size: 11px;\n    line-height: normal;\n    padding: 8px 22px;\n  }\n\n  &.btn-xs {\n    font-size: 10px;\n    line-height: 1.5;\n    padding: 6px 16px;\n  }\n\n  /* fancy button */\n  &.btn-fancy {\n    &.btn-xs {\n      font-size: 10px;\n      letter-spacing: 0.5px;\n      padding: 7px 18px;\n    }\n\n    &.btn-sm {\n      font-size: 11px;\n      letter-spacing: 0.5px;\n      padding: 10px 24px;\n    }\n\n    &.btn-md {\n      font-size: 12px;\n      letter-spacing: 1px;\n      padding: 12px 28px;\n    }\n\n    &.btn-lg {\n      font-size: 13px;\n      letter-spacing: 1px;\n      padding: 13px 32px;\n    }\n\n    &.btn-xl {\n      font-size: 15px;\n      letter-spacing: 1px;\n      padding: 18px 38px;\n    }\n  }\n\n  &.btn-gradient {\n    background: var(--brand-color);\n    color: var(--text-color);\n    border-color: transparent;\n    background-size: 200% auto;\n\n    &:active,\n    &:focus {\n      background: var(--brand-color);\n      border-color: transparent;\n      color: var(--text-color);\n      background-size: 200%;\n    }\n\n    &.btn-transparent {\n      background: transparent;\n      border-image-source: var(--brand-color);\n      border-image-slice: 1;\n    }\n\n    &:hover {\n      background-position: right center;\n    }\n  }\n\n  &.btn-fill {\n    background-color: var(--brand-color);\n\n    &:hover {\n      background-color: transparent;\n      color: var(--brand-color);\n    }\n  }\n\n  &[class*=\"btn-slide\"] {\n    position: relative;\n    z-index: 1;\n    overflow: hidden;\n    background-size: 200% auto;\n\n    &:focus,\n    &:active {\n      color: var(--text-color);\n    }\n\n    &.btn-slide-filling-up,\n    &.btn-slide-filling-down,\n    &.btn-slide-filling-left,\n    &.btn-slide-filling-right {\n\n      &:focus,\n      &:active {\n        &[role=\"button\"] {\n          border-color: transparent;\n        }\n      }\n    }\n\n    &:hover {\n      background-position: right center;\n    }\n\n    &:after {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: -1;\n      background: var(--brand-color);\n      transition: var(--default-transition);\n    }\n  }\n\n  &.btn-slide-up {\n    &::after {\n      transform: translateY(100%);\n    }\n\n    &:hover:not(:active) {\n      &:after {\n        transform: translateY(0);\n      }\n    }\n  }\n\n  &.btn-slide-down {\n    &:after {\n      transform: translateY(-100%);\n    }\n\n    &:hover:not(:active) {\n      &:after {\n        transform: translateY(0);\n      }\n    }\n  }\n\n  &.btn-slide-left {\n    &:after {\n      transform: translateX(100%);\n    }\n\n    &:hover:not(:active) {\n      &:after {\n        transform: translateX(0);\n      }\n    }\n  }\n\n  &.btn-slide-right {\n    &:after {\n      transform: translateX(-100%);\n    }\n\n    &:hover:not(:active) {\n      &:after {\n        transform: translateX(0);\n      }\n    }\n  }\n\n  &[class*=\"btn-slide-filling\"] {\n    &:not(:active) {\n      border-color: transparent;\n    }\n  }\n\n  &.btn-slide-filling-up {\n    &::after {\n      transform: translateY(100%);\n      background-color: var(--brand-color);\n    }\n\n    &:hover:not(:active) {\n      &:after {\n        transform: translateY(0);\n      }\n    }\n  }\n\n  &.btn-slide-filling-down {\n    &::after {\n      transform: translateY(calc(-100% - 1px));\n      background-color: var(--brand-color);\n    }\n\n    &:hover:not(:active) {\n      &:after {\n        transform: translateY(0);\n      }\n    }\n  }\n\n  &.btn-slide-filling-left {\n    &::after {\n      transform: translateX(100%);\n      background-color: var(--brand-color);\n    }\n\n    &:hover:not(:active) {\n      &:after {\n        transform: translateX(0);\n      }\n    }\n  }\n\n  &.btn-slide-filling-right {\n    &::after {\n      transform: translateX(calc(-100% - 1px));\n      background-color: var(--brand-color);\n    }\n\n    &:hover:not(:active) {\n      &:after {\n        transform: translateX(0);\n      }\n    }\n  }\n\n  &.btn-expand {\n    border: none;\n    background-color: transparent;\n    position: relative;\n    z-index: 1;\n\n    &:active,\n    &:focus {\n      color: var(--text-color) !important;\n    }\n\n    .right-icon {\n      transition: var(--default-transition);\n    }\n\n    &.rounded {\n      &:after {\n        border-radius: 50px;\n      }\n\n      &.btn-xl {\n        padding: 15px 28px 15px;\n\n        &:after {\n          width: 50px;\n          height: 50px;\n        }\n      }\n\n      &.btn-lg {\n        padding: 14px 26px 14px;\n\n        &:after {\n          width: 46px;\n          height: 46px;\n        }\n      }\n\n      &.btn-md {\n        padding: 7px 21px 7px;\n\n        &:after {\n          width: 32px;\n          height: 32px;\n        }\n      }\n\n      &.btn-sm {\n        padding: 7px 20px 7px;\n\n        &:after {\n          width: 30px;\n          height: 30px;\n        }\n      }\n\n      &.btn-xs {\n        padding: 5px 17px 5px;\n\n        &:after {\n          width: 25px;\n          height: 25px;\n        }\n      }\n    }\n\n    &:after {\n      content: \"\";\n      position: absolute;\n      top: 50%;\n      left: 0;\n      width: 50%;\n      height: 100%;\n      z-index: -1;\n      background-color: var(--brand-color);\n      transition: var(--default-transition);\n      transform: translateY(-50%);\n    }\n\n    &:hover {\n      .right-icon {\n        margin-left: 15px;\n      }\n\n      &:after {\n        width: 100% !important;\n        color: var(--text-color);\n      }\n    }\n  }\n\n  &.btn-link {\n    padding: 7px 0 2px;\n    position: relative;\n    border: 0;\n    background-color: transparent;\n    text-decoration: none;\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      bottom: -2px;\n      left: 0;\n      width: 100%;\n    }\n\n    &:focus-visible {\n      color: var(--text-color);\n      box-shadow: none;\n    }\n\n    &:hover {\n      opacity: 0.7;\n\n      &:after {\n        opacity: 0.7;\n      }\n    }\n  }\n\n  &.text-gradient {\n    background: var(--text-color);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n\n    &:focus,\n    &:active {\n      &[role=\"button\"] {\n        background: var(--text-color) !important;\n        -webkit-background-clip: text !important;\n        background-clip: text !important;\n        -webkit-text-fill-color: transparent;\n      }\n    }\n  }\n\n  &.btn-shadow {\n    letter-spacing: 1px;\n\n    &:hover {\n      box-shadow: 0 8px 30px -5px rgba(0, 0, 0, 0.2) !important;\n      -webkit-transform: translate3d(0, -3px, 0);\n      transform: translate3d(0, -3px, 0);\n      background-color: var(--brand-color) !important;\n      color: var(--text-color) !important;\n    }\n\n    &:focus,\n    &:active {\n      box-shadow: 0 8px 30px -5px rgba(0, 0, 0, 0.2) !important;\n      background-color: var(--brand-color) !important;\n      color: var(--text-color) !important;\n    }\n  }\n\n  &.btn-flat {\n    border-color: var(--brand-color);\n    color: var(--brand-color);\n    border-width: 1px;\n    background-color: transparent;\n    box-shadow: 2px 2px 0 var(--brand-color);\n\n    &:hover,\n    &:active,\n    &:focus {\n      background: var(--brand-color) !important;\n      border-color: transparent !important;\n      box-shadow: none !important;\n      color: var(--text-color) !important;\n    }\n  }\n\n  &.btn-sonar {\n    background-color: transparent;\n    display: flex;\n    font-size: 14px;\n    position: relative;\n    padding: 0;\n    line-height: 1;\n    justify-content: center;\n    align-items: center;\n    border-radius: 9999px;\n\n    &.btn-sm {\n      width: 40px;\n      height: 40px;\n      font-size: 14px;\n    }\n\n    &.btn-md {\n      width: 50px;\n      height: 50px;\n      font-size: 18px;\n    }\n\n    &.btn-lg {\n      width: 75px;\n      height: 75px;\n      font-size: 26px;\n    }\n\n    &.btn-xl {\n      width: 100px;\n      height: 100px;\n      font-size: 25px;\n    }\n\n    &.btn-xxl {\n      width: 120px;\n      height: 120px;\n      font-size: 34px;\n\n      @media (max-width:var(--sm)) {\n        width: 80px;\n        height: 80px;\n        font-size: 28px;\n      }\n    }\n\n    i {\n      position: relative;\n      z-index: 6;\n      color: var(--text-color);\n      margin-left: 8px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      opacity: 1;\n      top: 0;\n      left: 0;\n      --transform-translate-x: -50%;\n      --transform-translate-y: -50%;\n      width: 100%;\n      height: 100%;\n      border-radius: 9999px;\n      z-index: 5;\n      background: var(--brand-color);\n      background-size: 200%;\n    }\n\n    &::after {\n      content: \"\";\n      width: 150%;\n      height: 150%;\n      opacity: 2;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      --transform-translate-x: -50%;\n      --transform-translate-y: -50%;\n      border-radius: 9999px;\n      z-index: 3;\n      background: var(--brand-color);\n      animation: video-icon-sonar 2s linear infinite;\n    }\n\n    &:hover {\n      border: none;\n    }\n  }\n\n  .left-icon {\n    margin-right: 8px;\n  }\n\n  .right-icon {\n    margin-left: 8px;\n  }\n}\n\n@keyframes spin {\n  to {\n    -webkit-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n[type=\"submit\"] {\n  &.loading {\n    position: relative;\n\n    &:before {\n      content: \"\";\n      background-color: rgba(255, 255, 255, 0.8) !important;\n      position: absolute;\n      right: 2px;\n      top: 1px;\n      width: calc(100% - 4px);\n      height: calc(100% - 2px);\n      border-radius: inherit;\n      z-index: 1;\n    }\n\n    &:after {\n      background: 0 0;\n      content: \"\" !important;\n      position: absolute;\n      left: calc(50% - 10px) !important;\n      top: calc(50% - 10px) !important;\n      width: 20px !important;\n      height: 20px !important;\n      opacity: 1 !important;\n      right: inherit !important;\n      z-index: 9;\n      text-align: center;\n      border: 2px solid rgba(23, 23, 23, 0.2);\n      border-top-color: rgba(23, 23, 23, 0.7);\n      border-radius: 50%;\n      animation: spin 1s linear infinite;\n      -webkit-animation: spin 1s linear infinite;\n    }\n\n    &.dark {\n      &:before {\n        background-color: rgba(0, 0, 0, 0.8) !important;\n      }\n\n      &:after {\n        border: 2px solid rgba(255, 255, 255, 0.2);\n        border-top-color: rgba(255, 255, 255, 0.7);\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
